export default defineNuxtPlugin((nuxtApp) => {
    const getEventId = () => {
        const timestamp = Date.now();
        const randomPart = Math.random().toString(36).substring(2, 15);
        return `event_${timestamp}_${randomPart}`;
    };

    // Делаем доступным через useNuxtApp().$getEventId
    nuxtApp.provide('getEventId', getEventId);
});
